import { onMounted, onUnmounted, ref } from "vue";
import modalRegistry from "./modalRegistry";
import { lockScroll, unlockScroll } from "./scrollLock";

export function useModalStack(close: () => void) {
    const id = ref<number | null>(null);
    let escapeHandler: ((e: KeyboardEvent) => void) | null = null;

    onMounted(() => {
        id.value = modalRegistry.getId();

        escapeHandler = event => {
            if (event.key === "Escape" && modalRegistry.getLast() === id.value) {
                event.stopImmediatePropagation();
                close();
            }
        };
        window.addEventListener("keydown", escapeHandler);
    });

    onUnmounted(() => {
        if (escapeHandler) {
            window.removeEventListener("keydown", escapeHandler);
        }
    });

    function pushOpen() {
        modalRegistry.push(id.value as number);
        lockScroll();
    }

    function isTop(): boolean {
        return modalRegistry.getLast() === id.value;
    }

    function popClose(): boolean {
        if (!isTop()) {
            return false;
        }

        modalRegistry.pop();
        unlockScroll();
        return true;
    }

    return { id, pushOpen, popClose, isTop };
}
